var $26d76742decfd829$exports = {};
$26d76742decfd829$exports = {
    "Clear search": `Effacer la recherche`
};


export {$26d76742decfd829$exports as default};
//# sourceMappingURL=fr-FR.module.js.map
